<template>
  <div>
    <b-modal id="add-a-provider-modal" ref="addAProviderModal" hide-footer @hidden="resetValues" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
      <template slot="modal-title">IdP Information</template>
      <div class="provider-input-container">
        <span class="sequence">1.</span>
        <span class="title">Choose your IdP Provider</span>
        <div class="section1">
          <div class="form-group">
            <div class="heading">IdP Name</div>
            <CustomSelectSso v-if="!providerDetails.id" class="mb-8" ref="customSelectProvider" :options="providerNameList" :selected-option="providerDetails.providerId" option-label="name" @input="selectInputHandler" />
            <span v-else class="provider-edit" disabled>{{ providerDetails.name }}</span>
          </div>
          <div class="form-group">
            <div class="heading">IdP Type</div>
            <input type="text" id="saml-field" value="SAML" disabled />
          </div>
          <div class="form-group">
            <div class="heading">Region</div>
            <CustomSelectSso v-if="!providerDetails.id" class="mb-8" ref="customSelectRegion" :options="providerListRegion" :selected-option="providerDetails.regionName" option-label="displayName" @input="selectInputHandler" />
            <span v-else class="provider-edit" disabled>{{ providerDetails.regionName }}</span>
          </div>
        </div>
        <div class="section2">
          <span class="sequence">2.</span>
          <span class="title">Migrate THREAD Details</span>
          <div class="sub-title">
            The THREAD service provider details below must be copied and input into your IdP’s portal to gain <br />
            access to your SSO users.
          </div>
          <div class="table-item" id="table-item">
            Entity ID
            <span class="fa fa-info-circle" :id="`popover-target-entityId`"></span>
            <b-popover container="table-item" :target="`popover-target-entityId`" triggers="hover" placement="right">
              This may also be referred to<br />as ‘SP Entity ID’ or ‘Audience<br />
              URI’ within your IdP client.
            </b-popover>
            <div class="entity-id">{{ entityID }}<i v-if="entityID" class="fa fa-copy" @click="copyEntityID()" aria-hidden="true"></i></div>
          </div>
          <div class="div-with-line"></div>
          <div class="table-item">
            ACS URL
            <span class="fa fa-info-circle" :id="`popover-target-acsUrl`"></span>
            <b-popover container="table-item" :target="`popover-target-acsUrl`" triggers="hover" placement="right">
              This may also be referred to <br />as SAML Assertion <br />Consumer Service (ACS) <br />URL or Single sign on URL <br />
              within your IdP client.
            </b-popover>
            <div class="acs-url">{{ acsURL }}<i v-if="acsURL" class="fa fa-copy" aria-hidden="true" @click="copyACSURL()"></i></div>
          </div>
        </div>
        <div class="section3">
          <span class="sequence">3.</span>
          <span class="title">Select how you would like to import your IdP metadata.</span>
          <div class="radio-section">
            <input type="radio" accept=".xml" id="metadataFILE" name="metaType" v-model="providerDetails.metaType" value="FILE" checked />
            <label for="metadataFILE">Metadata Document</label>
            <input type="radio" id="metaUrl" name="metaType" v-model="providerDetails.metaType" value="URL" />
            <label for="metaUrl">Metadata URL</label>
          </div>
          <div v-if="providerDetails.metaType === 'FILE'" class="file-input-container">
            <div class="file-input">
              <input type="file" accept="application/xml" @change="onFileChange" ref="fileInput" style="display:none;" />
              <label for="fileInput" class="file-placeholder" v-if="providerDetails.metaType === 'FILE' && !providerDetails.metaFile">
                {{ providerDetails.metaFileName || "Browse files..." }}
              </label>
              <span v-else>{{ providerDetails.metaFileName }}</span>
            </div>

            <button class="btn btn-primary" @click="browseFiles">Browse</button>
          </div>
          <div v-else>
            <input type="text" class="text-field" v-model="providerDetails.metaUrl" />
          </div>
          <b-button class="btn-addprovider" :disabled="disableAddButton" variant="primary" @click="openSsoAcknowledgementModalModal()">Add IdP</b-button>
          <b-button class="btn-cancel" @click="onCloseModal">Cancel</b-button>
        </div>
      </div>
    </b-modal>
    <ssoAcknowledgementModal ref="ssoAcknowledgementModal" @providerAdded="idpProviderAdded($event)" />
  </div>
</template>
<script>
import ssoAcknowledgementModal from "@/components/sso-login/sso-acknowledgement-modal";
import CustomSelectSso from "@/components/sso-login/custom-select-sso";
import { cloneDeep } from "lodash";
import nprogress from "nprogress";
import "nprogress/nprogress.css";

export default {
  name: "add-a-provider-modal-component",
  data() {
    return {
      noCloseOnBackdrop: true,
      fileName: "",
      metaUrl: "",
      providerNameList: [],
      providerListRegion: [],
      entityID: "",
      acsURL: "",
      providerDetails: {
        providerId: null,
        regionId: null,
        metaType: "FILE",
        metaFile: null,
        metaFileName: null,
        metaUrl: null,
        file: "",
        s3UploadUrl: "",
        s3UploadPath: ""
      }
    };
  },
  components: {
    ssoAcknowledgementModal,
    CustomSelectSso
  },
  computed: {
    disableAddButton() {
      if (!this.providerDetails.providerId) {
        return true;
      }
      if (!this.providerDetails.regionId) {
        return true;
      }
      if (!this.entityID && !this.acsURL) {
        return true;
      }
      if (!this.providerDetails.metaType) {
        return true;
      }
      if (this.providerDetails.metaType == "URL" && !this.providerDetails.metaUrl) {
        return true;
      }
      if (this.providerDetails.metaType == "FILE" && !this.providerDetails.metaFileName) {
        return true;
      }
      return false;
    }
  },
  methods: {
    async show(providerObject) {
      this.getIDPProviderName();
      await this.getIDPProviderRegion();
      this.getS3UploadUrlDetails();
      if (providerObject) {
        this.providerDetails = cloneDeep(providerObject);
        this.getEntityIDAndAcsURL();
      }
      this.$emit("apiCallComplete");
      this.$refs.addAProviderModal.show();
    },
    openSsoAcknowledgementModalModal() {
      this.$refs.ssoAcknowledgementModal.show(this.providerDetails);
    },
    selectInputHandler(option) {
      if (option.hasOwnProperty("displayName")) {
        this.providerDetails.regionId = option.id;
        this.getEntityIDAndAcsURL();
      } else {
        this.providerDetails.providerId = option.id;
      }
    },
    copyEntityID() {
      navigator.clipboard.writeText(this.entityID).catch(error => {
        this.$toastr.error(`Clipboard write failed because of  ${error}`);
      });
    },
    copyACSURL() {
      navigator.clipboard.writeText(this.acsURL).catch(error => {
        this.$toastr.error(`Clipboard write failed because of  ${error}`);
      });
    },
    browseFiles() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      const allowedExtensions = /(\.xml)$/i;
      if (!allowedExtensions.exec(file.name)) {
        this.providerDetails.metaFile = null;
        this.providerDetails.metaFileName = null;
        this.fileName = "";
        return;
      }
      this.providerDetails.file = file;
      this.fileName = file.name;
      this.providerDetails.metaFileName = file.name;
      this.providerDetails.metaFile = "xml";
    },
    resetValues() {
      this.providerDetails = {
        providerId: null,
        regionId: null,
        metaType: "FILE",
        metaFile: null,
        metaFileName: null,
        metaUrl: null,
        file: ""
      };
      this.entityID = null;
      this.acsURL = null;
      this.fileName = "";
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
      if (this.$refs.customSelectProvider) {
        this.$refs.customSelectProvider.selected = null;
      }
      if (this.$refs.customSelectRegion) {
        this.$refs.customSelectRegion.selected = null;
      }
    },
    onCloseModal() {
      this.$emit("apiCallComplete");
      this.$refs.addAProviderModal.hide();
    },

    getIDPProviderName() {
      nprogress.start();
      this.$api.getProviderNameDetails().then(
        response => {
          this.providerNameList = response.data.data;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.data && error.data.message ? error.data.message : "Error while getting Provider Name details.");
        }
      );
    },
    async getIDPProviderRegion() {
      nprogress.start();
      await this.$api.getProviderRegionDetails().then(
        response => {
          this.providerListRegion = response.data.data;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.data && error.data.message ? error.data.message : "Error while getting Region details.");
        }
      );
    },
    getEntityIDAndAcsURL() {
      nprogress.start();
      const selectedRegion = this.providerListRegion.find(providerRegion => providerRegion.id === this.providerDetails.regionId);
      const region = selectedRegion ? selectedRegion.region : "";
      this.$api.updateEntityIDAndAcsURLDetails(region).then(
        response => {
          let decryptedPoolInfo = this.CryptoJS.AES.decrypt(response.body.data, `${process.env.VUE_APP_COGNITO_API_SECRET}`).toString(this.CryptoJS.enc.Utf8);
          decryptedPoolInfo = JSON.parse(decryptedPoolInfo);
          this.acsURL = decryptedPoolInfo.acsUrl;
          this.entityID = decryptedPoolInfo.entityId;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.data && error.data.message ? error.data.message : "Error while getting Entity ID and Acs URL Details.");
        }
      );
    },
    idpProviderAdded(providerDetails) {
      this.$emit("providerAdded", providerDetails);
    },
    getS3UploadUrlDetails() {
      nprogress.start();
      this.$api.getS3UploadUrlResource().then(
        response => {
          this.providerDetails.s3UploadUrl = response.body.data[0].url;
          this.providerDetails.s3UploadPath = response.body.data[0].path;
          nprogress.done();
        },
        error => {
          nprogress.done();
          this.$toastr.error(error.data && error.data.message ? error.data.message : "Error while getting details.");
        }
      );
    }
  }
};
</script>
<style lang="scss">
#add-a-provider-modal {
  @media (min-width: 1200px) {
    .modal-dialog {
      min-width: 750px;
      vertical-align: middle;
    }

    .modal-header {
      border-bottom: none !important;
    }
  }

  .modal-dialog {
    .modal-content {
      .modal-header {
        .modal-title {
          font-family: Roboto-Medium;
          color: #666669;
          font-size: 24px;
        }
      }
    }
  }
  .provider-input-container {
    .sequence {
      font-family: Roboto-Bold;
      text-align: left;
      color: #4a4a4a;
      font-size: 14px;
      margin-left: 5px;
    }

    .title {
      font-family: Roboto-Bold;
      font-size: 14px;
      font-stretch: normal;
      letter-spacing: normal;
      margin-left: 5px;
      color: #4a4a4a;
    }

    .form-group {
      display: inline-block;
      vertical-align: top;
      margin-right: 5px;
      margin-left: 23px;

      .label {
        display: block;
        margin-bottom: 5px;
      }

      select,
      input[type="text"] {
        width: 210px;
        padding: 3px;
        border: 1px solid #ccc;
        border-radius: 4px;
        font-family: Roboto-Medium;
        padding: 8px;
        color: #4a4a4a;
      }

      input {
        height: 34px;
        padding: 15px;
      }

      #saml-field {
        border: none;
        padding-left: 12px;
      }
    }

    .heading {
      font-family: Roboto-medium;
      font-size: 14px;
      margin-top: 16px;
      color: #666669;
    }

    .section2 {
      margin-top: 19px;
    }

    .section3 {
      margin-top: 40px;
    }

    .sub-title {
      margin-left: 23px;
      font-size: 14px;
      margin-top: 10px;
      margin-bottom: 10px;
      color: #666669;
      font-family: Roboto-Regular;
      margin-right: 10px;
    }

    .table-item {
      padding: 15px 24px 15px 16px;
      background-color: #f8f8f8;
      margin-left: 23px;
      color: #666669;
      font-family: Roboto-Medium;
      border-radius: 4px;
      font-size: 14px;
      .popover {
        width: 148px;
        max-width: 148px;
        font-size: 10px;
        color: #000;
        border: solid 1px #bdbdbd;
        line-height: normal;

        .popover-body {
          padding: 8px;
          color: #000;
          font-family: Roboto-Regular;
          border-radius: 4px;
        }
      }
    }

    .fa {
      font-size: 17px;
      padding-left: 3px;
    }

    .fa-info-circle {
      color: #ced4d9;
      cursor: pointer;
    }

    .div-with-line {
      flex-grow: 1;
      height: 1px;
      background-color: #dfd5d5;
      margin-left: 23px;
    }

    .entity-id {
      color: #4a4a4a;
      font-family: "Roboto-Regular";
    }

    .acs-url {
      color: #4a4a4a;
      font-family: "Roboto-Regular";
    }

    #metadataFILE {
      accent-color: #4c8ce4;
      margin-top: 10px;
      margin-left: 23px;
    }

    #metaUrl {
      accent-color: #4c8ce4;
      margin-top: 10px;
      margin-left: 23px;
    }

    .fa-copy {
      cursor: pointer;
      color: #4c8ce4;
      margin-left: 3px;
    }

    input[type="radio"] {
      margin-left: 42px;
      margin-top: 10px;
      margin-right: 5px;
      font-family: Roboto-Medium;
    }

    .file-input-container {
      display: flex;
      align-items: center;
      margin-top: 10px;
    }

    .file-input {
      display: inline-block;
      width: 85%;
      height: auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      padding-left: 12px;
      margin-left: 23px;
      padding-top: 5px;
      padding-bottom: 7px;
      font-family: "Roboto-Medium";

      .input[type="file"] {
        display: none;
      }

      .file-name {
        font-size: 14px;
      }
    }
    .file-placeholder {
      display: initial;
    }

    .text-field {
      display: inline-block;
      width: 95%;
      height: auto;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin-left: 23px;
      margin-top: 10px;
      color: #666669;
      padding-left: 10px;
      font-size: 14px;
      font-family: "Roboto-Medium";
      padding: 6px;
      padding-left: 12px;
    }

    .btn-primary {
      display: inline-block;
      padding: 6px 16px;
      border-radius: 4px;
      border: solid 1px #ced4d9;
      background-color: #fff !important;
      cursor: pointer;
      font-family: Roboto-Medium;
      color: #508ee1 !important;
      font-size: 14px;
      font-weight: 500;
      margin-left: 10px;
    }

    .btn-addprovider {
      padding: 5px 12px;
      border-radius: 4px;
      color: #fff !important;
      border: solid 1px #508ee1 !important;
      background-color: #508ee1 !important;
      cursor: pointer;
      font-family: Roboto-Medium;
      font-size: 14px !important;
      letter-spacing: normal;
      float: right;
      margin-top: 40px;
    }

    .btn-cancel {
      padding: 5px 12px;
      border-radius: 4px;
      color: #508ee1 !important;
      border: solid 1px rgba(145, 158, 171, 0.24);
      background-color: #fff !important;
      cursor: pointer;
      font-family: Roboto-Medium;
      font-size: 14px !important;
      letter-spacing: normal;
      float: right;
      margin-right: 10px;
      margin-top: 40px;
      margin-bottom: 10px;
      width: 80px;
    }

    span.provider-edit {
      width: 210px;
      display: inline-block;
      font-family: Roboto-Medium;
      border: none;
      padding: 0.5em;
      cursor: default;
      color: #4a4a4a;
      background-color: #f8f8f8;
      height: 34px;
      border-radius: 4px;
      padding: 8px;
    }
  }
}
</style>
